module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text/12-ea86880d52f8b65e5bc8d5440123ee72.jpg";